import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowRefresh04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.2 20.267A9.603 9.603 0 0 1 8.4 3.049m0 14.302v4.8H3.6M16.8 3.734a9.6 9.6 0 0 1 4.8 8.315 9.6 9.6 0 0 1-6 8.902m0-14.302v-4.8h4.8"
    />
  </svg>
);
export default SvgArrowRefresh04;
